import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import PhotographService from "./PhotographsService";


export const getPhotographs = createAsyncThunk("Photograph/get-Photographs", async (thunkAPI) => {
  try {
    return await PhotographService.getPhotographs();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createPhotographs = createAsyncThunk(
  "Photograph/create-Photographs",
  async (PhotographData, thunkAPI) => {
    try {
      return await PhotographService.createPhotographs(PhotographData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getPhotograph = createAsyncThunk(
  "Photograph/get-Photograph",
  async (id, thunkAPI) => {
    try {
      return await PhotographService.getPhotograph(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updatePhotograph = createAsyncThunk(
  "Photograph/update-Photograph",
  async (brand, thunkAPI) => {
    try {
      return await PhotographService.updatePhotograph(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAPhotograph = createAsyncThunk(
  "Photograph/delete-Photograph",
  async (id, thunkAPI) => {
    try {
      return await PhotographService.deletePhotograph(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Photographs: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const PhotographSlice = createSlice({
  name: "Photograph",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPhotographs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPhotographs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Photographs = action.payload.data;
      })
      .addCase(getPhotographs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createPhotographs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPhotographs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdPhotograph = action.payload;
      })
      .addCase(createPhotographs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getPhotograph.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPhotograph.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Photographtype = action.payload.data.type;
        state.PhotographshortName= action.payload.data.shortName;
        state.Photographemail= action.payload.data.email;
        state.PhotographName= action.payload.data.name;
        
       
        
        
        
      })
      .addCase(getPhotograph.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updatePhotograph.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePhotograph.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedPhotograph = action.payload;
      })
      .addCase(updatePhotograph.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAPhotograph.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAPhotograph.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedPhotograph = action.payload;
      })
      .addCase(deleteAPhotograph.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default PhotographSlice.reducer;
